import { MEDIA_QUERIES, SPACINGS } from 'shared/styles/variables';
import styled from 'styled-components';

// We can add more cols over time but this seems like a sane starting point.
interface SectionProps {
  cols?: 1 | 2 | 3 | 4;
  colsMobile?: 1 | 2 | 3 | 4;
}

/**
 * Form layout helper that can subdivide rows into multiple columns, which
 * allows for half and quarter width form fields.
 */
const Section = styled('section')<SectionProps>`
  display: grid;
  grid-template-columns: repeat(${(p) => p.cols || 1}, 1fr);
  grid-gap: ${SPACINGS.base * 3}px;
  margin: 0;

  @media ${MEDIA_QUERIES.isMobile} {
    grid-template-columns: repeat(${(p) => p.colsMobile || 1}, 1fr);
  }

  /**
   * TODO: PER-1771
   * Currently the spacing exists in <FormGroup/> for backwards compatibility
   * as margin-bottom.
   * We also have one-off styles for buttons since they don't get wrapped with
   * <FormGroup/>.
   * Once all forms are migrated, delete margin-bottom there and remove
   * grid-row-gap and button styles here.
   **/
  grid-row-gap: 0;
`;

export default Section;
